import {gql} from '@apollo/client'

export const CREATE_RESOURCE_CATEGORY = gql`
  mutation createResourceCategory($categoryData: resource_category_input!) {
    createResourceCategory(categoryData: $categoryData) {
      success
      category {
        id
        name
        parent {
          id
        }
        order
        isActive
      }
      errors {
        field
        message
      }
    }
  }
`

export const UPDATE_RESOURCE_CATEGORY = gql`
  mutation updateResourceCategory($id: Int!, $categoryData: resource_category_input!) {
    updateResourceCategory(id: $id, categoryData: $categoryData) {
      success
      category {
        id
        name
        parent {
          id
        }
        order
        isActive
      }
      errors {
        field
        message
      }
    }
  }
`

export const DELETE_RESOURCE_CATEGORY = gql`
  mutation deleteResourceCategory($id: Int!) {
    deleteResourceCategory(id: $id) {
      success
      message
      errors {
        field
        message
      }
    }
  }
`
